import { createStore } from 'vuex';
import cards from './modules/cards';
import companyPlanModule from './modules/companyPlanModule';
import dialogUpload from './modules/dialogUpload';
import indications from './modules/indications';
import individualPlanModule from './modules/individualPlanModule';
import companyManagementModule from './modules/companyManagementModule';
import userManagementModule from './modules/userManagementModule';
import userActions from './modules/userActions';
import plansModule from './modules/plansModule';
import sectorsModule from './modules/sectorsModule';

export default createStore({
    modules: {
        cards,
        individualPlanModule,
        companyPlanModule,
        dialogUpload,
        indications,
        userManagementModule,
        companyManagementModule,
        userActions,
        plansModule,
        sectorsModule,
    }
})
